// extracted by mini-css-extract-plugin
export default {"socialList":"ListSocialNetworks_socialList__U0ADs","socialListItems":"ListSocialNetworks_socialListItems__w0NC7","socialListLink":"ListSocialNetworks_socialListLink__hBRoz"};